import { GrcNotify, NotifyType } from '@grc/ui-package';
import notify from '../../common/notify';

// No cross-call de-dup cache here: fetchData's cancellation (useGetApiData) is scoped to the
// calling component's lifecycle, so sharing one promise by request key across independent
// callers let one caller's cancellation (e.g. React StrictMode's mount->cleanup->remount cycle)
// resolve an unrelated, still-live caller's settings to {} instead of the real data.
export const getAnySettings = async (
  url: string,
  fetchData: any,
  tenantService: any,
  inputParams: any
): Promise<{}> => {
  try {
    const response: any = await fetchData(url, notify, tenantService, inputParams);

    if (response?.status === 200 && response.data) {
      return response.data;
    }

    return {};
  } catch (error: any) {
    GrcNotify({
      message: error.message,
      status: NotifyType.Error
    });
    return {};
  }
};
